import axios from "axios";

const JWT = {

    getRefreshToken(){
        return window.localStorage.getItem('jwt') || null;
    },

    hasRefreshToken(){
        return this.getRefreshToken() ? true : false;
    },

    setRefreshToken(token){
        window.localStorage.setItem('jwt', token);
        return this;
    },

    removeRefreshToken(){
        window.localStorage.removeItem('jwt');
        return this;
    },

    getAccessToken(){
        const bearer = axios.defaults.headers.common['Authorization'] || null; 
        return bearer ? bearer.substring(7, bearer.length) : null;
    },

    hasAccessToken(){
        return this.getAccessToken() ? true : false;
    },

    setAccessToken(token){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token; 
        return this;
    },

    removeAccessToken(){
        delete axios.defaults.headers.common['Authorization'];
        return this;
    },

   setTokens(data){
        return this.setAccessToken(data.accessToken).setRefreshToken(data.refreshToken);
    },

    removeTokens(){
        return this.removeAccessToken().removeRefreshToken();
    },

}

export default JWT;